import { h } from "preact";
import SearchComponent from "./SearchComponent";
import { useState } from "preact/hooks";
import TermFilterComponent from "./TermFilterComponent";
import TermListComponent from "./TermListComponent";
import UrlFilter from "../UrlFilter";

function MainComponent() {
    const [terms, setTerms] = useState({});
    const [filter, setFilter] = useState(null);
    const [fetchedData, setFetchedData] = useState(false);

    /**
     * @param terms
     */
    function updateTerms(terms) {
        let filteredUrlParam = null;
        const urlFilter = new UrlFilter();
        setTerms(terms);

        // let's check the first filter letter if there is no selected OR selected letter does not have any results
        filteredUrlParam = urlFilter.filter;
        if (terms[filteredUrlParam] !== undefined) {
            setFilter(filteredUrlParam);
        } else {
            filteredUrlParam = null;
        }
        if (
            (filter === null && terms && Object.keys(terms).length !== 0 && filteredUrlParam === null) // TODO: create const to remove duplicated parts
            || (terms[filter] === undefined && Object.keys(terms).length !== 0 && filteredUrlParam === null)
        ) {
            // set default filter letter
            setFilter(Object.keys(terms).sort()[0]);
        }
    }

    /**
     * @param filter
     */
    function updateFilter(filter) {
        setFilter(filter);
        const urlFilter = new UrlFilter();
        urlFilter.setFilter(filter);
    }

    function updateFetchedData() {
        setFetchedData(true);
    }

    return (
        <div>
            <SearchComponent updateTerms={updateTerms} fetchedData={fetchedData} updateFetchedData={updateFetchedData}/>
            <TermFilterComponent terms={terms} filter={filter} updateFilter={updateFilter}/>
            <TermListComponent filter={filter} terms={terms} fetchedData={fetchedData}/>
        </div>
    );
}

export default MainComponent;